import Http from '@/utils/http'
import {
  TRIP_ENDPOINT,
  START_TRIP,
  registerPassengersEndpoint } from './urls'

export const postTrip = (data) => Http.post(TRIP_ENDPOINT, data)
export const getTrip = (id) => {
  return Http.get(`${TRIP_ENDPOINT + id}/`)
}
export const getTrips = () => Http.get(TRIP_ENDPOINT)
export const deleteTrip = (id) => {
  return Http.delete(`${TRIP_ENDPOINT + id}/`)
}
export const putTrip = (data) => {
  return Http.put(`${TRIP_ENDPOINT + data.id}/`, data)
}

export const startTrip = () => {
  return Http.post(START_TRIP)
}

export const endTrip = () => {}

export const registerPassengers = (id, data) => {
  return Http.post(registerPassengersEndpoint(id), data)
}

export const getTripPassengers = (id) => {
  return Http.get(`${TRIP_ENDPOINT + id}/passengers/`)
}



// WEBPACK FOOTER //
// ./src/services/trip.js